// common-modal.component.ts
import { Component, Inject, TemplateRef } from '@angular/core';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

export interface ModalData {
  title?: string;
  contentTemplate?: TemplateRef<any>;
  context?: any;
  showActions?: boolean;
}

@Component({
  standalone: true,
  selector: 'app-common-modal',
  templateUrl: './common-modal.component.html',
  styleUrl: './common-modal.component.scss',
  imports: [CommonModule, MatDialogModule, MatButtonModule],
})
export class CommonModalComponent {
  constructor(
    public dialogRef: MatDialogRef<CommonModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModalData
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
